import { RequestStatus } from '@/pages/team/teamMember/requests/RequestsTable.types';
import { FC } from 'react';

const leaveChipStyles: Record<RequestStatus, string> = {
  [RequestStatus.Approved]: 'bg-green-50 text-green-700 border-green-200',
  [RequestStatus.Denied]: 'bg-red-50 text-red-700 border-red-200',
  [RequestStatus.Pending]: 'bg-gray-100 text-gray-600 border-gray-200',
  [RequestStatus.Cancelled]: 'bg-gray-100 text-gray-600 border-gray-200'
};

export const LeaveStatusChit: FC<{ status: RequestStatus }> = ({ status }) => (
  <span
    className={`inline-block shrink-0 rounded-md border px-2 py-1 text-sm font-semibold ${leaveChipStyles[status]}`}
  >
    {status}
  </span>
);
